import { useMediaQuery } from 'react-responsive';

export interface IMediaBreakpoints {
  [key: string]: boolean;
  isMobile: boolean;
  isMobileOrTablet: boolean;
  isTablet: boolean;
  isTabletOrDesktop: boolean;
  isDesktop: boolean;
}

export function useMediaQueries(): IMediaBreakpoints {
  const isMobile = useMediaQuery({ maxWidth: 480 });
  const isMobileOrTablet = useMediaQuery({ maxWidth: 989 });
  const isTablet = useMediaQuery({ minWidth: 481, maxWidth: 989 });
  const isTabletOrDesktop = useMediaQuery({ minWidth: 769 });
  const isDesktop = useMediaQuery({ minWidth: 990 });

  return <IMediaBreakpoints>{
    isMobile,
    isMobileOrTablet,
    isTablet,
    isTabletOrDesktop,
    isDesktop,
  };
}
